import { render, staticRenderFns } from "./fctory_band_spplierManage.vue?vue&type=template&id=dec818fa&scoped=true"
import script from "./fctory_band_spplierManage.vue?vue&type=script&lang=js"
export * from "./fctory_band_spplierManage.vue?vue&type=script&lang=js"
import style0 from "./fctory_band_spplierManage.vue?vue&type=style&index=0&id=dec818fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec818fa",
  null
  
)

export default component.exports